import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        backend: {
            loadPath: '/api/bootstrapper/resources/{{ns}}.json',
        },
        ns: ['AnelmaGeneral'],
        defaultNS: 'AnelmaGeneral',
        fallbackLng: 'fi',
        interpolation: { escapeValue: false },
        returnNull: false,
    });

export default i18n;
